export default __webpack_public_path__ + "static/media/1F62E55D-9412-4856-95A5-C7F738BC3331_1_105_c.a35e4add.jpeg";